import Dialog from '@/components/Dialog';
import { TextField, type TextFieldProps } from '@mui/material';
import { useContext } from 'react';
import PromptTextFieldInjectedPropsContext from './PromptTextFieldInjectedPropsContext';
import isTouchDevice from '@/lib/utils/isTouchDevice';

export type PromptTextFieldProps = Omit<
  TextFieldProps,
  'variant' | 'maxRows' | 'fullWidth'
>;

const PromptTextField = ({
  minRows,
  autoFocus,
  ...props
}: PromptTextFieldProps) => {
  const injectedProps = useContext(PromptTextFieldInjectedPropsContext);

  return (
    <Dialog.Content style={{ marginTop: -12 }}>
      <TextField
        variant="filled"
        minRows={minRows ?? 4}
        maxRows={6}
        autoFocus={
          typeof autoFocus !== 'undefined' ? autoFocus : !isTouchDevice()
        }
        fullWidth
        {...injectedProps}
        {...props}
      />
    </Dialog.Content>
  );
};

export default PromptTextField;
